import React from 'react';
import {StyleSheet, View} from 'react-native';

import {getSkeletonColors, STAGGER} from '../constants';
import {BoneBadge} from '../primitives/BoneBadge';
import {BoneButton} from '../primitives/BoneButton';
import {BoneImage} from '../primitives/BoneImage';
import {BoneText} from '../primitives/BoneText';

/**
 * Skeleton for product carousel cards.
 * Mirrors: ProductTile layout (TILE_DIMENSIONS.width=150, containerPadding=8)
 * Reference: app/components/ProductTile/styles.ts
 */
export const ProductCardSkeleton: React.FC = React.memo(() => (
  <View style={styles.container}>
    <BoneBadge animationDelay={STAGGER.delay(0)} />
    <View style={styles.imageWrapper}>
      <BoneImage variant="product" animationDelay={STAGGER.delay(1)} />
    </View>
    <BoneText variant="h1" animationDelay={STAGGER.delay(2)} />
    <BoneText variant="body" width="65%" animationDelay={STAGGER.delay(3)} />
    <View style={styles.pricingBlock}>
      <BoneText variant="caption" width="80%" animationDelay={STAGGER.delay(4)} />
      <BoneText variant="price" animationDelay={STAGGER.delay(5)} />
      <BoneText variant="caption" width="45%" animationDelay={STAGGER.delay(6)} />
    </View>
    <BoneButton animationDelay={STAGGER.delay(7)} />
  </View>
));

ProductCardSkeleton.displayName = 'ProductCardSkeleton';

const styles = StyleSheet.create({
  container: {
    width: 150,
    padding: 8,
    backgroundColor: getSkeletonColors().cardBackground,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: getSkeletonColors().border,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.15,
    shadowRadius: 3,
    elevation: 3,
    gap: 6,
  },
  imageWrapper: {
    alignItems: 'center',
    marginVertical: 4,
  },
  pricingBlock: {
    gap: 4,
    minHeight: 70,
  },
});
